/* Dusty Gems Y2K — global UI behaviors */
(function () {
  'use strict';

  const ready = (fn) =>
    document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn);

  /* ---------- Welcome dialog persistence ---------- */
  function initWelcomeDialogs() {
    document.querySelectorAll('[data-dg-welcome]').forEach((el) => {
      const id = el.dataset.dgWelcome || 'default';
      const key = `dg-welcome-closed:${id}`;
      if (sessionStorage.getItem(key) === '1') {
        el.classList.add('is-closed');
      }
      el.querySelectorAll('[data-dg-close]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          el.classList.add('is-closed');
          sessionStorage.setItem(key, '1');
        });
      });
    });
  }

  /* ---------- Boot sequence (first visit only) ---------- */
  function initBootSequence() {
    const boot = document.querySelector('[data-dg-boot]');
    if (!boot) return;
    if (sessionStorage.getItem('dg-booted') === '1') {
      boot.remove();
      return;
    }
    const lines = boot.querySelectorAll('.dg-boot__line');
    let i = 0;
    const reveal = () => {
      if (i >= lines.length) {
        setTimeout(() => {
          boot.classList.add('is-hidden');
          sessionStorage.setItem('dg-booted', '1');
          setTimeout(() => boot.remove(), 500);
        }, 400);
        return;
      }
      lines[i].classList.add('is-visible');
      i++;
      setTimeout(reveal, 220);
    };
    setTimeout(reveal, 200);
  }

  /* ---------- Window close buttons (decorative) ---------- */
  function initWindowButtons() {
    document.querySelectorAll('[data-dg-window-close]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const win = btn.closest('.dg-window');
        if (win) win.style.display = 'none';
      });
    });
  }

  /* ---------- Reduced motion bridge ---------- */
  function applyReducedMotion() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.body.classList.add('dg-reduced-motion');
    }
  }

  ready(() => {
    applyReducedMotion();
    initBootSequence();
    initWelcomeDialogs();
    initWindowButtons();
  });
})();
